<div id="section0" class="container-fluid py-2" *ngIf="ke">
  <form [formGroup]="formGroup">
    <!-- Bug 6961: Shutter, Branchline, beamlines and the type radios stack full width below lg instead of squeezing four across -->
    <div class="row align-items-center">
      <div class="col-12 col-lg">
        <mat-form-field appearance="outline" class="no-subscript" *ngIf="checkShutter(ke)">
          <mat-label>{{ shuttersLoading ? "Loading shutters..." : "Shutter" }}</mat-label>
          <input
            matInput
            placeholder="Shutter"
            #locationInput
            formControlName="shutterCtrl"
            [matAutocomplete]="autoLoc"
            (keyup)="onLocChange($event)"
            #trigger="matAutocompleteTrigger"
          />
          <mat-progress-spinner
            *ngIf="shuttersLoading"
            matSuffix
            class="mr-2"
            diameter="18"
            mode="indeterminate"
          ></mat-progress-spinner>
          <mat-autocomplete
            #autoLoc="matAutocomplete"
            (optionSelected)="selectedLoc($event)"
            #locationAutocomplete
            [displayWith]="displayObject"
          >
            <mat-option *ngIf="shuttersLoading && !filteredShutters.length" disabled>
              Loading shutters...
            </mat-option>
            <mat-option
              *ngFor="let shutter of filteredShutters"
              [value]="shutter"
              [disabled]="shutter.id != null && disabledShutterIds.has(shutter.id)"
            >
              {{ shutter.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg" *ngIf="showbranch">
        <div class="flex-display">
          <mat-form-field appearance="outline" class="no-subscript" *ngIf="checkBranchline(ke)">
            <mat-label>Branchline</mat-label>
            <input
              matInput
              placeholder="Branchline"
              #branchlineInput
              formControlName="branCtrl"
              [matAutocomplete]="autoBran"
              #trigger="matAutocompleteTrigger"
            />
            <mat-autocomplete
              #autoBran="matAutocomplete"
              (optionSelected)="selectedBran($event)"
              #branchlineAutocomplete
              [displayWith]="displayObject"
            >
              <mat-option
                *ngFor="let branchline of branchlines"
                [value]="branchline"
                [disabled]="disabledBranchlineIds.has(branchline.id)"
              >
                {{ branchline.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      <div class="col-12 col-lg">
        <h5>{{ beamlines }}</h5>
      </div>
      <div class="col-12 col-lg">
        <mat-radio-group
          aria-label="Select an option"
          class="radio-group"
          #radioGroup
          [disabled]="disabled"
        >
          <mat-radio-button
            *ngFor="let r of brOptions"
            class="radio-button"
            [value]="r.value"
            [checked]="r.checked"
            (change)="radioChanged($event)"
          >
            {{ r.label }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </form>
</div>
